import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Button,
  Chip,
  CircularProgress,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchProject = async () => {
    try {
      const response = await axios.get(`${API_URL}/projects/${id}`);
      setProject(response.data.project);
    } catch (error) {
      console.error('Error fetching project:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!project) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography>Project not found</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/projects')} sx={{ mb: 2 }}>
        Back to Projects
      </Button>
      <Typography variant="h4" component="h1" gutterBottom>
        {project.name}
      </Typography>
      <Chip label={project.status} color="primary" sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Addresses
              </Typography>
              {project.current_address && (
                <Box mb={2}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Current Address
                  </Typography>
                  <Typography>{project.current_address}</Typography>
                </Box>
              )}
              {project.rental_address && (
                <Box mb={2}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Rental Address
                  </Typography>
                  <Typography>{project.rental_address}</Typography>
                </Box>
              )}
              {project.rebuilt_address && (
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Rebuilt Address
                  </Typography>
                  <Typography>{project.rebuilt_address}</Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Dates
              </Typography>
              {project.redevelopment_start_date && (
                <Box mb={2}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Redevelopment Period
                  </Typography>
                  <Typography>
                    {new Date(project.redevelopment_start_date).toLocaleDateString()} -{' '}
                    {project.redevelopment_end_date
                      ? new Date(project.redevelopment_end_date).toLocaleDateString()
                      : 'Ongoing'}
                  </Typography>
                </Box>
              )}
              {project.rental_start_date && (
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Rental Period
                  </Typography>
                  <Typography>
                    {new Date(project.rental_start_date).toLocaleDateString()} -{' '}
                    {project.rental_end_date
                      ? new Date(project.rental_end_date).toLocaleDateString()
                      : 'Ongoing'}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box mt={3} display="flex" gap={2}>
        <Button variant="contained" onClick={() => navigate('/furniture')}>
          Manage Furniture
        </Button>
        <Button variant="outlined" onClick={() => navigate('/space-planning')}>
          Space Planning
        </Button>
        <Button variant="outlined" onClick={() => navigate('/bookings')}>
          Book Services
        </Button>
      </Box>
    </Container>
  );
};

export default ProjectDetail;

